import { PropsWithChildren, ReactNode } from 'react';

import Wrapper from '@/components/shared/Wrapper';
import styled, { StyledProp, css, cx } from '@/styled';

interface IProps {
  centralized?: string;
}

const OfferContainer = (props: IProps & PropsWithChildren<StyledProp> & { image: ReactNode }) => {
  return (
    <div className={cx(props.className, 'offer-container')}>
      <Wrapper className={`wrapperContent ${props.centralized}`}>
        <div className='offerContentCentered'>
          <div className={`offerTextBlock ${props.centralized}`}>{props.children}</div>
        </div>
      </Wrapper>

      <picture className='offerCover'>{props.image}</picture>

      <div className='offerCover-shadow' />
    </div>
  );
};
export default styled(OfferContainer)`
  ${({ theme }) => css`
    width: 100%;
    background: ${theme.colorBgBase};
    position: relative;

    .containerButtonsOffers {
      display: flex;
      align-items: center;

      ${theme.breakpoints.down('md')} {
        flex-direction: column;
        align-items: flex-start;
      }
    }

    .textCenter {
      text-align: center;
      width: 100% !important;
      max-width: 100% !important;
    }

    .wrapperContent {
      z-index: 2;
      position: absolute;
      height: 100%;
      margin-top: 0;
      margin-bottom: 0;
    }

    .offerContentCentered {
      height: 100%;
      display: flex;
      align-items: center;
    }

    .offerTextBlock {
      display: flex;
      flex-direction: column;
      gap: ${theme.space.spacing(4)};
      width: 100%;
      max-width: 465px;

      ${theme.breakpoints.down('sm')} {
        width: 286px;
      }

      .titleOffer {
        padding: 0;
        margin: 0;

        ${theme.breakpoints.down('sm')} {
          font-size: ${theme.fontSizeXL}px;
        }
      }

      .resumeOffer {
        font-size: 20px;
        font-weight: 400;
        color: ${theme.variables.resumeOfferButton.color};

        ${theme.breakpoints.down('sm')} {
          display: none;
        }
      }
    }

    .offerCover {
      position: relative;

      img {
        width: 100%;
        aspect-ratio: 4 / 1;
        object-fit: cover;
        min-height: 420px;
      }
    }

    .handleButtonOffer,
    .handleButtonSeeMore {
      height: 40px;
      font-weight: 500;
      transition: ${theme.motionDurationMid};
      background: ${theme.variables.resumeOfferButton.background};
      color: ${theme.variables.resumeOfferButton.color};
      border-color: ${theme.variables.resumeOfferButton.border};
    }

    .handleButtonSeeMore {
      margin-left: 12px;
      background-color: ${theme.variables.resumeSeeMoreButton.background};
      border-color: ${theme.variables.resumeSeeMoreButton.border};
      color: ${theme.variables.resumeSeeMoreButton.color};

      ${theme.breakpoints.down('md')} {
        margin-left: 0;
        margin-top: 12px;
      }
    }

    .offerCover-shadow {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: linear-gradient(0deg, ${theme.variables.shadowEffect} 0%, rgba(20, 20, 20, 0) 50%),
        linear-gradient(0deg, ${theme.variables.shadowEffect} 0%, rgba(20, 20, 20, 0) 50%);
      background-image: -webkit-linear-gradient(0deg, ${theme.variables.shadowEffect} 0%, rgba(20, 20, 20, 0) 50%),
        linear-gradient(0deg, ${theme.variables.shadowEffect} 0%, rgba(20, 20, 20, 0) 50%);
    }
  `}
`;
